module.exports = __webpack_public_path__ + "img/组 7471.de37b6ec.png";